import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AppButtonComponent } from 'src/app/shared/components/app-button/app-button.component';
import { AppFormModalComponent } from 'src/app/shared/components/app-form-modal/app-form-modal.component';
import { AppTicketCardComponent } from 'src/app/shared/components/app-ticket-card/app-ticket-card.component';

import { ModalService } from 'src/app/core/services/modal.service';
import { SelectModel } from 'src/app/shared/components/app-select-input/app-select-input.component';
import { FormControl } from '@angular/forms';
import {
  MemberService,
  MemberSituationEnum,
} from 'src/app/core/services/member.service';
import { UserModel } from 'src/app/shared/models/userModel';
import { UserService } from 'src/app/core/services/user.service';
import { WaveService } from 'src/app/core/services/wave.service';
import { AlertService, AlertType } from 'src/app/core/services/alert.service';
import { Router } from '@angular/router';
import { GuestService } from 'src/app/core/services/guest.service';
import { SubstituteService } from 'src/app/core/services/substitute.service';
import { AppConfirmModalComponent } from '../../shared/components/app-confirm-modal/app-confirm-modal.component';
import { AppModalChangeCheckinComponent } from '../../shared/components/app-modal-change-checkin/app-modal-change-checkin.component';
import { AppChoosePaymentModalComponent } from 'src/app/shared/components/app-choose-payment-modal/app-choose-payment-modal.component';
import { InvoiceService } from 'src/app/core/services/invoice.service';

@Component({
  selector: 'app-check-in',
  standalone: true,
  imports: [
    CommonModule,
    AppButtonComponent,
    AppTicketCardComponent,
    AppFormModalComponent,
    AppConfirmModalComponent,
    AppModalChangeCheckinComponent,
    AppChoosePaymentModalComponent
  ],
  templateUrl: './check-in.component.html',
  styleUrl: './check-in.component.scss',
})
export class CheckInComponent implements OnInit {
  labelColor = 'white';
  user: UserModel;
  memberData: any;
  memberPlan: any;
  memberDependents: any = [];
  selectInputOptionsModal: SelectModel[] = [];
  checkinSelected: any;
  checkinsHistory: any = [];
  linkModalConfirm: string = '';
  limitCheckin: any;
  pendentTicket: any;
  showDiv = false;
  guestSelect: any;
  substituteSelect: any;
  hasCheckinBtn: boolean = true;
  isAtLeast12: boolean = false;
  isSenior: boolean = false;
  isSecondaryPlan = localStorage.getItem('isSecondaryPlan') === 'true';
  membershipCardData: any;
  paymentModalData: any;

  ingressosCheckIn: any[] = [];

  buttonBackOptions = {
    buttonText: 'Voltar',
    buttonSize: 'btn btn-md px-3 btn-secondary',
    borderRadius: '25px',
  };

  constructor(
    private modalService: ModalService,
    private userService: UserService,
    private waveService: WaveService,
    private guestService: GuestService,
    private substituteService: SubstituteService,
    private router: Router,
    private alertService: AlertService,
    private memberService: MemberService,
    private invoiceService: InvoiceService
  ) {
    this.user = this.userService.currentUserValue as UserModel;
    if (
      this.user?.memberSituation?.id != MemberSituationEnum.Adimplente &&
      !this.isSecondaryPlan
    ) {
      this.router.navigate(['/dashboard']);
    }
  }

  ngOnInit(): void {
    this.hasCheckinBtn = JSON.parse(
      localStorage.getItem('activeSections') as string
    )['ingressos'];

    this.validateAccess();

    this.memberService.getMemberPlanDashboardData(this.user.id, this.isSecondaryPlan).subscribe({
      next: (res) => {
        this.memberPlan = res;
        if (this.memberPlan) {
          this.waveService
            .getNextActivesWaves(this.memberPlan.plan.id)
            .subscribe((data) => {
              this.ingressosCheckIn = data;
              this.showDiv = true;
            });

          this.memberService.getMemberDashboardData(this.user.id).subscribe((res) => {
            this.memberData = res;

            if (res.birthDate) {
              const birth = new Date(res.birthDate);
              const now = new Date();
              let age = now.getFullYear() - birth.getFullYear();
              const m = now.getMonth() - birth.getMonth();
              if (m < 0 || (m === 0 && now.getDate() < birth.getDate())) {
                age--;
              }
              this.isAtLeast12 = age >= 12;
              this.isSenior = age >= 65;
            }

            let option: SelectModel = {
              code: res.id,
              name: `${res.name} (Sócio)`,
            };
            this.selectInputOptionsModal.push(option);

            if (this.memberData) {
              this.memberService
                .getMemberDependentesByMember(this.memberData.id, this.memberPlan.id)
                .subscribe((data) => {
                  this.memberDependents = data;
                  data.content.forEach((dep) => {
                    let optionDep: SelectModel = {
                      code: dep.id,
                      name: `${dep.name} (Dependente)`,
                    };
                    this.selectInputOptionsModal.push(optionDep);
                  });
                });

              this.memberService.getMemberShipCardDashboardData(this.memberData.id, this.memberPlan.id).subscribe(res => {
                this.membershipCardData = res;
              })
            }
          });
        }
      },
      error: (e) => {
        console.error('Error:', e);
        this.alertService.showAlert(AlertType.WARNING, e.error.message);
      },
    });
  }

  modalBodyMessage = 'Deseja realizar o check-in?';
  modalId = 'modalCheckinTicket';
  selectControlModal: FormControl = new FormControl();

  async openCheckInModal(event: any): Promise<void> {
    const wave = this.ingressosCheckIn.find(w => w.id === event);
    if (this.user.allowCheckin === false) {
      if ((!wave.isAvaliableNoDocsMinors && !this.isAtLeast12) || (!wave.isAvaliableNoDocsSeniors && this.isSenior) || (!this.isSenior && this.isAtLeast12 && this.user.allowCheckin === false)) {
        this.alertService.showAlert(
          AlertType.WARNING,
          'Você está com pendência de documentos ou com check-in bloqueado. Entre em contato com a equipe de atendimento.'
        );
        return;
      }
    }

    try {
      this.checkinsHistory = await this.waveService
        .getCheckinsRealizados(event, this.user.id)
        .toPromise();
      this.limitCheckin = await this.waveService
        .getLimitByMemberPlan(this.memberPlan.id)
        .toPromise();
    } catch (error) {
      console.error('Error:', error);
    }
    this.checkinSelected = event;
    this.modalService.open(this.modalId);
  }

  onModalFormConfirm(event: any) {
    if (event.isDependent) {
      const dependentSelect = this.memberDependents.content.find((i: any) => i.id === event.clientSelected);

      const missingFields = this.validDependent(dependentSelect);
      if (missingFields.length > 0) {
        this.alertService.showAlert(
          AlertType.WARNING,
          `Dependente com dados incompletos. Campos obrigatórios não preenchidos: ${missingFields}.`
        );
        return;
      }
    }

    if (event.isSubstitute && event.substituteData && event.substituteTax) {
      this.invoiceService.createSubstituteTaxInvoice(this.memberPlan.id, event.substituteTax.id).subscribe({
        next: (res) => {
          if (res.invoicePaymentStatus !== '7859ffd3-9390-4d25-89a6-8f27533bb37e') { // Pago
            setTimeout(() => {
              this.paymentModalData = { invoice: res, checkin: event };
              this.modalService.open('modalChoosePayment');
            }, 400);
          } else {
            this.onModalConfirm(event);
          }
        },
        error: (error) => {
          console.error('Error:', error);
          this.alertService.showAlert(
            AlertType.WARNING,
            `Não foi possível gerar a fatura da taxa de substituição. Tente novamente.`
          );
        }
      });
    } else if (!event.isSubstitute && !event.substituteData && event.checkinTax) {
      this.invoiceService.createCheckinTaxInvoice(this.memberPlan.id, event.checkinTax.id).subscribe({
        next: (res) => {
          if (res.invoicePaymentStatus !== '7859ffd3-9390-4d25-89a6-8f27533bb37e') { // Pago
            setTimeout(() => {
              this.paymentModalData = { invoice: res, checkin: event };
              this.modalService.open('modalChoosePayment');
            }, 400);
          } else {
            this.onModalConfirm(event);
          }
        },
        error: (error) => {
          console.error('Error:', error);
          this.alertService.showAlert(
            AlertType.WARNING,
            `Não foi possível gerar a fatura da taxa de substituição. Tente novamente.`
          );
        }
      });
    } else {
      this.onModalConfirm(event);
    }
  }


  async onModalConfirm(event: any): Promise<void> {
    const waveSelect = this.ingressosCheckIn.find((i: any) => i.id === this.checkinSelected);

    let dependentSelect: any;
    if (event.isDependent) {
      dependentSelect = this.memberDependents.content.find((i: any) => i.id === event.clientSelected);
    }

    if (event.isGuest && event.guestData) {
      let guestPayload: any = {
        id: event.guestData.idControl ? event.guestData.idControl : '',
        name: event.guestData.nameControl,
        cpf: event.guestData.cpfControl,
        email: event.guestData.emailControl,
      };

      try {
        this.guestSelect = await this.guestService
          .createGuestCheckin(guestPayload)
          .toPromise();
      } catch (error) {
        console.error('Error:', error);
      }
    }

    if (event.isSubstitute && event.substituteData) {
      let substitutePayload: any = {
        id: event.substituteData.idControl
          ? event.substituteData.idControl
          : '',
        name: event.substituteData.nameControl,
        cpf: event.substituteData.cpfControl,
        email: event.substituteData.emailControl,
      };

      try {
        this.substituteSelect = await this.substituteService
          .createSubstituteCheckin(substitutePayload)
          .toPromise();
      } catch (error) {
        console.error('Error:', error);
      }
    }

    if (waveSelect?.waveGame?.ticketsApiType?.id === '2649821c-02d2-407e-9cf5-0a1741a9ec37') {

      this.waveService.verifyFacialStatusImply(event.isDependent
        ? dependentSelect?.cpf
        : event.isGuest
          ? event.guestData.cpfControl
          : event.isSubstitute
            ? event.substituteData.cpfControl
            : this.memberData?.cpf).subscribe({
              next: (res: any) => {
                if (res.error == null && res.result.code === 20000) {

                  let checkinImplyPayload: any = {
                    memberId: this.memberData.id,
                    memberName: event.isDependent
                      ? dependentSelect?.name
                      : event.isGuest
                        ? event.guestData.nameControl
                        : event.isSubstitute
                          ? event.substituteData.nameControl
                          : this.memberData?.name,
                    memberDocument: event.isDependent
                      ? dependentSelect?.cpf
                      : event.isGuest
                        ? event.guestData.cpfControl
                        : event.isSubstitute
                          ? event.substituteData.cpfControl
                          : this.memberData?.cpf,
                    eventId: waveSelect.waveGame.event,
                    ticketId: event.ticketSelected,
                    code: event.isDependent
                      ? dependentSelect?.membershipCard?.cardNumber
                      : event.isGuest
                        ? '1' + event.guestData.cpfControl
                        : event.isSubstitute
                          ? '1' + event.substituteData.cpfControl
                          : this.membershipCardData?.cardNumber
                  }

                  let isUpdate = this.validIsUpdate(event, this?.checkinsHistory);

                  if (isUpdate) {

                    let jaExiste = this.validJaExiste(event, this?.checkinsHistory);

                    if (jaExiste) {
                      this.alertService.showAlert(
                        AlertType.WARNING,
                        `Já existe um checkin gerado para este usuário nesse jogo!`
                      );
                    } else {
                      this.waveService.updateCheckinImply(checkinImplyPayload).subscribe({
                        next: (res: any) => {
                          if (res.error != null) {
                            if (res.error.code === 20006) {
                              this.alertService.showAlert(
                                AlertType.WARNING,
                                `Já existe um checkin gerado para este usuário!`
                              );
                            } else {
                              console.error('Error: ', res.error);
                              this.alertService.showAlert(
                                AlertType.WARNING,
                                `Não foi possível realizar o checkin, tente novamente mais tarde!`
                              );
                            }

                          } else {

                            let parsed = JSON.parse(res.result);
                            let orderId = parsed.key;
                            let checkinPayload: any = {
                              waveId: this.checkinSelected,
                              ticketId: event.isDependent
                                ? waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected).id
                                : event.isGuest
                                  ? waveSelect.waveTicketsGuest.find((i: any) => i.ticketId === event.ticketSelected).id
                                  : waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected).id,
                              memberPlanId: this.memberPlan.id,
                              memberDependentId: event.isDependent ? event.clientSelected : '',
                              guestCheckinId: event.isGuest ? this.guestSelect?.id : '',
                              substituteCheckinId: event.isSubstitute ? this.substituteSelect?.id : '',
                              ticketLink: window.location.origin + '/check-in/detalhe/' + orderId,
                              ticketValue: event.isDependent
                                ? waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected).ticketValue
                                : event.isGuest
                                  ? waveSelect.waveTicketsGuest.find((i: any) => i.ticketId === event.ticketSelected).ticketValue
                                  : waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected).ticketValue,
                              ticketCode: event.isDependent
                                ? dependentSelect?.membershipCard?.cardNumber
                                : event.isGuest
                                  ? '1' + event.guestData.cpfControl
                                  : event.isSubstitute
                                    ? '1' + event.substituteData.cpfControl
                                    : this.membershipCardData?.cardNumber,
                              orderId: orderId,
                              checkinTaxId: event?.checkinTax?.id || null
                            };

                            this.waveService.criarCheckin(checkinPayload).subscribe((data) => {
                              this.alertService.showAlert(
                                AlertType.SUCCESS,
                                'Checkin realizado com sucesso.'
                              );
                              // const newTab = window.open('', '_blank');
                              // if (newTab) {
                              //   newTab.location.href = res.link;
                              // } else {
                              //   window.location.href = res.link;
                              // }
                              window.location.reload();
                            });

                          }
                        }, error: (error) => {
                          console.error('Error: ', error);
                        },
                      })
                    }
                  } else {
                    this.waveService.realizarCheckinImply(checkinImplyPayload).subscribe({
                      next: (res: any) => {
                        if (res.error != null) {
                          if (res.error.code === 20006) {
                            this.alertService.showAlert(
                              AlertType.WARNING,
                              `Já existe um checkin gerado para este usuário!`
                            );
                          } else {
                            console.error('Error: ', res.error);
                            this.alertService.showAlert(
                              AlertType.WARNING,
                              `Não foi possível realizar o checkin, tente novamente mais tarde!`
                            );
                          }

                        } else {

                          let parsed = JSON.parse(res.result);
                          let orderId = parsed.key;
                          let checkinPayload: any = {
                            waveId: this.checkinSelected,
                            ticketId: event.isDependent
                              ? waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected).id
                              : event.isGuest
                                ? waveSelect.waveTicketsGuest.find((i: any) => i.ticketId === event.ticketSelected).id
                                : waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected).id,
                            memberPlanId: this.memberPlan.id,
                            memberDependentId: event.isDependent ? event.clientSelected : '',
                            guestCheckinId: event.isGuest ? this.guestSelect?.id : '',
                            substituteCheckinId: event.isSubstitute ? this.substituteSelect?.id : '',
                            ticketLink: window.location.origin + '/check-in/detalhe/' + orderId,
                            ticketValue: event.isDependent
                              ? waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected).ticketValue
                              : event.isGuest
                                ? waveSelect.waveTicketsGuest.find((i: any) => i.ticketId === event.ticketSelected).ticketValue
                                : waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected).ticketValue,
                            ticketCode: event.isDependent
                              ? dependentSelect?.membershipCard?.cardNumber
                              : event.isGuest
                                ? '1' + event.guestData.cpfControl
                                : event.isSubstitute
                                  ? '1' + event.substituteData.cpfControl
                                  : this.membershipCardData?.cardNumber,
                            orderId: orderId,
                            checkinTaxId: event?.checkinTax?.id || null
                          };

                          this.waveService.criarCheckin(checkinPayload).subscribe((data) => {
                            this.alertService.showAlert(
                              AlertType.SUCCESS,
                              'Checkin realizado com sucesso.'
                            );
                            // const newTab = window.open('', '_blank');
                            // if (newTab) {
                            //   newTab.location.href = res.link;
                            // } else {
                            //   window.location.href = res.link;
                            // }
                            window.location.reload();
                          });

                        }
                      }, error: (error) => {
                        console.error('Error: ', error);
                      },
                    })
                  }
                } else if (res.error == null && res.result.code === 20002) {
                  this.alertService.showAlert(
                    AlertType.INFO,
                    `Seu cadastro de Facial está em análise, aguarde alguns instantes até que seja validado e tente novamente mais tarde`
                  );
                } else {
                  this.alertService.showAlert(
                    AlertType.INFO,
                    `Status da Facial: ${res.error != null ? 'Facial não cadastrada' : res.result?.msg}. Você será redirecionado para realizar a validação facial!`
                  );

                  let setPessoaPayload: any = {
                    de_para: event.isDependent
                      ? dependentSelect?.cpf
                      : event.isGuest
                        ? event.guestData.cpfControl
                        : event.isSubstitute
                          ? event.substituteData.cpfControl
                          : this.memberData?.cpf,
                    nome: event.isDependent
                      ? dependentSelect?.name
                      : event.isGuest
                        ? event.guestData.nameControl
                        : event.isSubstitute
                          ? event.substituteData.nameControl
                          : this.memberData?.name,
                    cpf: event.isDependent
                      ? dependentSelect?.cpf
                      : event.isGuest
                        ? event.guestData.cpfControl
                        : event.isSubstitute
                          ? event.substituteData.cpfControl
                          : this.memberData?.cpf,
                    email: event.isDependent
                      ? event.emailDependent ? event.emailDependent : dependentSelect?.email
                      : event.isGuest
                        ? event.guestData.emailControl
                        : event.isSubstitute
                          ? event.substituteData.emailControl
                          : this.memberData?.emails[0]?.email,
                    dt_nascimento: event.isDependent ? dependentSelect?.birthDate : this.memberData?.birthDate,
                    informacoes_extras: {
                      redirect_url: window.location.href
                    }
                  }

                  this.waveService.registerFacialImply(setPessoaPayload).subscribe({
                    next: (res: any) => {
                      if (res.error != null) {
                        this.alertService.showAlert(
                          AlertType.WARNING,
                          `Não foi possível cadastrar a facial, tente novamente mais tarde!`
                        );
                      } else {
                        let token = res.result;
                        let urlFacial = `https://ahmangueirao.eleventickets.com/OAuth2/external?token=${token}&url=aHR0cHM6Ly9haG1hbmd1ZWlyYW8uZWxldmVudGlja2V0cy5jb20vRmFjaWFsUmVjb2duaXRpb24%3D`;
                        window.location.href = urlFacial;
                      }
                    }, error: (error) => {
                      console.error('Error: ', error);
                    },
                  })

                }

              }, error: (error) => {
                console.error('Error: ', error);
              },
            });
    } else {
      let ticketPayload: any = {
        customer: {
          name: event.isDependent
            ? dependentSelect?.name
            : event.isGuest
              ? event.guestData.nameControl
              : event.isSubstitute
                ? event.substituteData.nameControl
                : this.memberData?.name,
          doc: event.isDependent
            ? dependentSelect?.cpf
            : event.isGuest
              ? event.guestData.cpfControl
              : event.isSubstitute
                ? event.substituteData.cpfControl
                : this.memberData?.cpf,
          email: event.isDependent
            ? event.emailDependent ? event.emailDependent : dependentSelect?.email
            : event.isGuest
              ? event.guestData.emailControl
              : event.isSubstitute
                ? event.substituteData.emailControl
                : this.memberData?.emails[0]?.email,
          mifare: event.isDependent
            ? dependentSelect?.membershipCard?.cardNumber
              ? dependentSelect?.membershipCard?.cardNumber
              : ''
            : `1${this.memberData.cpf}`,
          phones: [event.isDependent && dependentSelect?.phone ? dependentSelect?.phone : this.memberData.phones[0].number],
          birthDate: event.isDependent ? dependentSelect?.birthDate : this.memberData?.birthDate
        },
        tickets: [
          {
            ticketId: event.ticketSelected,
            ticketValue: event.isDependent
              ? waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
              : event.isGuest
                ? waveSelect.waveTicketsGuest.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                : event.isSubstitute
                  ? waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                  : this.isSenior && waveSelect.waveTicketsSeniors?.length > 0
                    ? waveSelect.waveTicketsSeniors.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                    : this.isAtLeast12 && waveSelect.waveTicketsMinors?.length > 0
                      ? waveSelect.waveTicketsMinors.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                      : waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue,
            customer: {
              name: event.isDependent
                ? dependentSelect?.name
                : event.isGuest
                  ? event.guestData.nameControl
                  : event.isSubstitute
                    ? event.substituteData.nameControl
                    : this.memberData?.name,
              doc: event.isDependent
                ? dependentSelect?.cpf
                : event.isGuest
                  ? event.guestData.cpfControl
                  : event.isSubstitute
                    ? event.substituteData.cpfControl
                    : this.memberData?.cpf,
              email: event.isDependent
                ? event.emailDependent ? event.emailDependent : dependentSelect?.email
                : event.isGuest
                  ? event.guestData.emailControl
                  : event.isSubstitute
                    ? event.substituteData.emailControl
                    : this.memberData?.emails[0]?.email,
              mifare: event.isDependent
                ? dependentSelect?.membershipCard?.cardNumber
                  ? dependentSelect?.membershipCard?.cardNumber
                  : ''
                : `1${this.memberData.cpf}`,
              phones: [event.isDependent && dependentSelect?.phone ? dependentSelect?.phone : this.memberData.phones[0].number],
            },
          },
        ],
      };

      this.waveService.realizarCheckin(ticketPayload).subscribe({
        next: (res: any) => {
          if (res?.mandatoryFace && event?.isGuest) {
            this.linkModalConfirm = res?.link;
            this.modalService.open('modalConfirm');
          }

          if (res.orderStatus && res?.orderStatus === 'Initial') {
            this.pendentTicket = res;
            this.modalService.open('modalChangeCheckin');
          } else if (res?.mandatoryFace) {
            const newTab = window.open('', '_blank');
            if (newTab) {
              newTab.location.href = res?.link; // Define a URL da aba já aberta
            } else {
              window.location.href = res.link;  // Tenta abrir normalmente se a aba não foi criada
            }
          } else {
            let checkinPayload: any = {
              waveId: this.checkinSelected,
              ticketId: event.isDependent
                ? waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected)?.id
                : event.isGuest
                  ? waveSelect.waveTicketsGuest.find((i: any) => i.ticketId === event.ticketSelected)?.id
                  : event.isSubstitute
                    ? waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected)?.id
                    : this.isSenior && waveSelect.waveTicketsSeniors?.length > 0
                      ? waveSelect.waveTicketsSeniors.find((i: any) => i.ticketId === event.ticketSelected)?.id
                      : !this.isAtLeast12 && waveSelect.waveTicketsMinors?.length > 0
                        ? waveSelect.waveTicketsMinors.find((i: any) => i.ticketId === event.ticketSelected)?.id
                        : waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected)?.id,
              memberPlanId: this.memberPlan.id,
              memberDependentId: event.isDependent ? event.clientSelected : '',
              guestCheckinId: event.isGuest ? this.guestSelect?.id : '',
              substituteCheckinId: event.isSubstitute
                ? this.substituteSelect?.id
                : '',
              ticketLink: res?.link || '',
              ticketValue: event.isDependent
                ? waveSelect.waveTicketsDependent.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                : event.isGuest
                  ? waveSelect.waveTicketsGuest.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                  : event.isSubstitute
                    ? waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                    : this.isSenior && waveSelect.waveTicketsSeniors?.length > 0
                      ? waveSelect.waveTicketsSeniors.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                      : this.isAtLeast12 && waveSelect.waveTicketsMinors?.length > 0
                        ? waveSelect.waveTicketsMinors.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue
                        : waveSelect.waveTicketsSocio.find((i: any) => i.ticketId === event.ticketSelected)?.ticketValue,
              ticketCode: res?.codes[0] || '',
              orderId: res.orderId,
              checkinTaxId: event?.checkinTax?.id || null
            };

            this.waveService.criarCheckin(checkinPayload).subscribe((data) => {
              this.alertService.showAlert(
                AlertType.SUCCESS,
                'Checkin realizado com sucesso.'
              );
              const newTab = window.open('', '_blank');
              if (newTab) {
                newTab.location.href = res.link;
              } else {
                window.location.href = res.link;
              }
              window.location.reload();
            });
          }
        },
        error: (error) => {
          console.error('Error: ', error);
        },
      });
    }
  }

  validJaExiste(event: any, history: any) {
    if (!history) {
      return false;
    } else if (event.isGuest && history.find((i: any) => i.memberGuestId != null && i.checkinStatus == 'Realizado')) {
      return true;
    } else if (event.isDependent && history.find((i: any) => i.memberDependentId != null && i.checkinStatus == 'Realizado')) {
      return true;
    }
    else if (event.isSubstitute && history.find((i: any) => i.memberSubstituteId != null && i.checkinStatus == 'Realizado')) {
      return true;
    }
    else if (!event.isGuest && !event.isSubstitute && !event.isDependent &&
      history.find((i: any) => i.memberPlanId != null && !i.isDependent && !i.isGuest && !i.isSubstitute && i.checkinStatus == 'Realizado')) {
      return true;
    }
    else {
      return false;
    }
  }

  validIsUpdate(event: any, history: any) {
    if (!history) {
      return false;
    } else if (event.isGuest && history.find((i: any) => i.memberGuestId != null && i.checkinStatus == 'Cancelado')) {
      return true;
    } else if (event.isDependent && history.find((i: any) => i.memberDependentId != null && i.checkinStatus == 'Cancelado')) {
      return true;
    }
    else if (event.isSubstitute && history.find((i: any) => i.memberSubstituteId != null && i.checkinStatus == 'Cancelado')) {
      return true;
    }
    else if (!event.isGuest && !event.isSubstitute && !event.isDependent &&
      history.find((i: any) => i.memberPlanId != null && !i.isDependent && !i.isGuest && !i.isSubstitute && i.checkinStatus == 'Cancelado')) {
      return true;
    }
    else {
      return false;
    }
  }

  validDependent(dependent: any): string {
    const missingFields = [];

    if (!dependent?.name) {
      missingFields.push('Nome');
    }
    if (!dependent?.cpf) {
      missingFields.push('CPF');
    }
    if (!dependent?.email) {
      missingFields.push('E-mail');
    }
    if (!dependent?.membershipCard?.cardNumber) {
      missingFields.push('Carteirinha');
    }
    if (!dependent?.birthDate) {
      missingFields.push('Data de Nascimento');
    }

    return missingFields.join(', ');
  }

  // Método de validação de acesso
  private validateAccess(): void {
    const activeSections = localStorage.getItem('activeSections');

    if (!activeSections) {
      this.handleAccessDenied();
      return;
    }

    const parsedSections = JSON.parse(activeSections);

    if (!parsedSections['ingressos']) {
      this.handleAccessDenied();
    }
  }

  // Tratamento de acesso negado
  private handleAccessDenied(): void {
    this.alertService.showAlert(
      AlertType.WARNING,
      'Você não possui acesso a essa página'
    );
    this.router.navigate(['/dashboard']);
  }

  back(): void {
    window.history.back();
  }
}
